<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <div class="text-overline">リース情報</div>
              <span>
                <v-chip :color="leasePayment.state == 1 << 2 ? 'success' : 'warning'" small>
                  {{ leasePayment.state | leasePaymentState }}
                </v-chip>
                {{ leasePayment.leaseCompanyType | leasePaymentCompanyType }}
              </span>
            </v-list-item-title>

            <v-list-item-subtitle>
              <span>審査提出日{{ leasePayment.examinationDate | date }} </span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card flat>
          <v-card-text>
            <v-row>
              <v-col cols="3">審査提出日</v-col>
              <v-col cols="9" v-html="$options.filters.date(leasePayment.examinationDate)"></v-col>
            </v-row>

            <v-row>
              <v-col cols="3">審査結果</v-col>
              <v-col cols="9" v-html="$options.filters.leasePaymentState(leasePayment.state)"></v-col>
            </v-row>

            <v-row>
              <v-col cols="3">入金予定日</v-col>
              <v-col cols="9" v-html="$options.filters.date(leasePayment.completeScheduleDate)"></v-col>
            </v-row>

            <v-row>
              <v-col cols="3">入金日</v-col>
              <v-col cols="9" v-html="$options.filters.date(leasePayment.completeDate)"></v-col>
            </v-row>

            <v-row>
              <v-col cols="3">備考</v-col>
              <v-col cols="9" v-html="$options.filters.md(leasePayment.memo)"></v-col>
            </v-row>

            <v-row v-if="leasePayment.meta.ngMessage != null">
              <v-col cols="3">NG理由</v-col>
              <v-col cols="9" v-html="$options.filters.md(leasePayment.meta.ngMessage)"></v-col>
            </v-row>

            <v-subheader>内訳</v-subheader>
            <v-simple-table>
              <thead>
                <tr>
                  <th>報告</th>
                  <th>結果</th>
                  <th>リース会社</th>
                  <th>提出日</th>
                  <th>結果日</th>
                  <th>備考</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(result, i) in examinationResult.results" :key="i">
                  <td><v-icon v-if="result.report" v-text="'mdi-check'" color="success" left /></td>
                  <td>
                    <v-chip :color="result.state == 1 << 2 ? 'success' : 'warning'" small>
                      {{ result.state | leasePaymentState }}
                    </v-chip>
                  </td>
                  <td>{{ result.leaseCompanyType | leasePaymentCompanyTypeShort }}</td>
                  <td>{{ result.examinationDate | date }}</td>
                  <td>{{ result.examinationResultDate | date }}</td>
                  <td><span v-html="$options.filters.nl2br(result.memo)"></span></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: {
    leasePayment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    examinationResult() {
      if (this.leasePayment.examinationResult != null && Array.isArray(this.leasePayment.examinationResult.results)) {
        return this.leasePayment.examinationResult;
      }
      return {
        results: [],
      };
    },
  },
  data: () => ({}),
  methods: {},
  watch: {},
  mounted() {
    // this.onLoaded();
  },
};
</script>